import React , { Component } from 'react';
import {Field, Form} from 'formik';
import _ from "lodash";
import AppVariables from "../../common/AppVariables";
import PlatformRender from "../PlatformRender/PlatformRender";
import {DevicePlatforms} from "../../common/Constants";
import OtpInput from "react-code-input";
import PropTypes from 'prop-types';

const CodeInputView = ({ name , inputs , pattern , type , size , className , minWidth = 530 }) => {

    return <Field name={name}
                  render={({ field , form: { isSubmitting , errors , setFieldValue } }) => {

        const otpProps = {
            type,
            value: field.value,
            disabled: isSubmitting,
            isValid: errors[name],
            containerStyle: { justifyContent: 'center' },
            fields: inputs,
            autoFocus: true,
            pattern,
            onChange: value => {
                setFieldValue(name,value);
            }
        };

        return <div style={{ minWidth }} className={className}>

            <PlatformRender platform={DevicePlatforms.Desktop}>
                <OtpInput {...otpProps}
                          inputStyle={{
                              width: `${5 * size}em`,
                              height: `${4 * size}em`,
                              borderRadius: 4,
                              border: "1px solid rgba(0, 0, 0, 0.3)",
                              margin: 4,
                              fontSize: '1em',
                              fontWeight: 'bold',
                              textAlign: 'center',
                              padding: '0.1em'
                          }}/>
            </PlatformRender>

            <PlatformRender platform={DevicePlatforms.Mobile}>

                <OtpInput {...otpProps}
                          inputStyle={{
                              width: `${3.5 * size}em`,
                              height: `${3 * size}em`,
                              borderRadius: 4,
                              border: "1px solid rgba(0, 0, 0, 0.3)",
                              margin: 4,
                              fontSize: '1em',
                              fontWeight: 'bold',
                              textAlign: 'center',
                              padding: '0.1em'
                          }}/>

            </PlatformRender>

        </div>
    }}/>
};

CodeInputView.propTypes = {
    inputs: PropTypes.number,
    type: PropTypes.string,
    pattern: PropTypes.string,
    name: PropTypes.string,
    size: PropTypes.number,
    className: PropTypes.string
};

CodeInputView.defaultProps = {
    inputs: _.min(AppVariables.ValidTokenLengths),
    type: 'text',
    pattern: '[a-zA-Z0-9]',
    name: 'activation_code',
    size: 1
};

export default CodeInputView;


// WEBPACK FOOTER //
// ./src/components/CodeInputView/CodeInputView.js